module.exports = __webpack_public_path__ + "static/media/image.e7d7105b.png";